import React, { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';

import { useAppDispatch, useAppSelector } from './store/hooks';
import { getUser } from './store/actions/user';
import { selectUserLoaded } from './store/selectors/user';

import ErrorFallback from './containers/ErrorFallback';
import PageHeader from './components/Layout/Page/PageHeader';
import Header from './components/Navigation/Header';
import Sidebar from './components/Navigation/Sidebar';
import PageSidebar from './components/Layout/Page/PageSidebar';
import Page from './components/Layout/Page';
import MainAppContent from './MainAppContent';
import PageLoader from './components/Feedback/Loader/PageLoader';
import MobileHeader from './components/Navigation/MobileHeader';
import MobileMenu from './components/Navigation/MobileMenu';

import useMobileDetect from './hooks/useMobileDetect';

import('./assets/svg/sprite.svg');

const MainApp = () => {
  const [isMenuMobileOpened, setIsMobileMenuOpened] = useState(false);

  const dispatch = useAppDispatch();
  const isUserLoaded = useAppSelector(selectUserLoaded);
  const isMobile = useMobileDetect();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpened((state) => !state);
  };

  useEffect(() => {
    dispatch(getUser());
  }, [dispatch]);

  if (!isUserLoaded) {
    return <PageLoader />;
  }

  if (isMobile) {
    return (
      <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
        <Page isMobile={isMobile}>
          <MobileHeader isMenuOpened={isMenuMobileOpened} toggleMenu={toggleMobileMenu} />
          {isMenuMobileOpened && <MobileMenu onMenuClick={() => setIsMobileMenuOpened(false)} />}
          <MainAppContent />
        </Page>
      </Sentry.ErrorBoundary>
    );
  }

  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <Page>
        <PageHeader>
          <Header />
        </PageHeader>
        <PageSidebar>
          <Sidebar />
        </PageSidebar>
        <MainAppContent />
      </Page>
    </Sentry.ErrorBoundary>
  );
};

export default MainApp;
